export const raceConditionQueryKeys = {
  all: () => "race-condition"
};
